import { useEffect, useMemo, useState } from 'react';
const useGroupedColumnSelector = (groups) => {
    const [selectedEvent, setSelectedEvent] = useState(null);
    const [selectedMetrics, setSelectedMetrics] = useState([]);
    const metrics = useMemo(() => {
        return (selectedEvent === null || selectedEvent === void 0 ? void 0 : selectedEvent.columns) || [];
    }, [selectedEvent]);
    const forceAddRequiredMetrics = () => {
        const metricsCopy = [...selectedMetrics];
        const metricNames = metricsCopy.map((metric) => metric.value);
        for (const group of groups) {
            for (const event of group.events) {
                for (const column of event.columns) {
                    if (column.alwaysEnabled && !metricNames.includes(column.value)) {
                        metricsCopy.push(column);
                    }
                }
            }
        }
        setSelectedMetrics(metricsCopy);
    };
    const updateSelectedMetrics = () => {
        const newMetrics = [];
        for (const group of groups) {
            for (const event of group.events) {
                for (const column of event.columns) {
                    if (column.selected && !newMetrics.map((metric) => metric.value).includes(column.value)) {
                        newMetrics.push(column);
                    }
                }
            }
        }
        setSelectedMetrics(newMetrics);
    };
    const refreshSelectedEvent = () => {
        if (selectedEvent) {
            for (const group of groups) {
                for (const event of group.events) {
                    if (event.name === selectedEvent.name) {
                        setSelectedEvent(event);
                    }
                }
            }
        }
    };
    useEffect(() => {
        forceAddRequiredMetrics();
        updateSelectedMetrics();
    }, [groups]);
    useEffect(() => {
        refreshSelectedEvent();
    }, [groups, selectedEvent, setSelectedEvent]);
    return {
        selectedEvent,
        setSelectedEvent,
        selectedMetrics,
        setSelectedMetrics,
        metrics,
    };
};
export default useGroupedColumnSelector;
//# sourceMappingURL=UseGroupedColumnSelector.js.map